import React from "react";
import "./Navbar.css";
import logo from "../../images/logo.jpg";

const Navbar = () => {
    return (
      <nav className="navbar">
        <div className="container">
          <div className="logo">
            <img className="logo-image" src={logo} alt="Logo" />
          </div>
          <ul className="nav-links">
            <li>
              <a href="#hero">
                 Home
              </a>
            </li>
            <li>
              <a href="#servicos">
                 Serviços
              </a>
            </li>
            <li>
              <a href="#sobre">
                Sobre Nós
              </a>
            </li>
            <li>
              <a href="#conquistas">
                Diferenciais
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  };
  

export default Navbar;
